import React, { FC } from "react";

import { TModalComponentsListProps } from "../../types/ContentHubSeriesDetails.type";
import InnerSplitModule from "./InnerSplitModule";
import "./styles.scss";

const InnerSplitModules: FC<TModalComponentsListProps> = (props) => {
  const model = props.components;

  return (
    <section className="inner-split-modules">
      {model?.map((component, index) => (
        <InnerSplitModule
          component={component}
          key={`inner-split-module-item-${index}`}
        />
      ))}
    </section>
  );
};

export default InnerSplitModules;
